<div class="quiz-questions" *ngIf="initialized" [@slideAnimation]="'fade'">
  <div class="quiz-carousel">
    <div class="quiz-carousel-slide" *ngFor="let question of puzzleConfig.questions; let i = index">
      <div class="quiz-carousel-card"
           [ngClass]="{'flipped': paused}"
           *ngIf="i === quizGameState.currentQuestion"
           [@slideAnimation]="'jackInTheBox'">
        <ion-card class="quiz-card-face quiz-card-front puzzle-elevation-z3" style="padding: 0;">
          <ion-toolbar color="primary" style="position: absolute; top: 0; left: 0; right: 0;">
            <ion-buttons slot="start">
              <ion-button (click)="prevQuestion()"
                          [disabled]="quizGameState.currentQuestion <= 0">
                <ion-icon name="arrow-back-sharp" slot="icon-only"></ion-icon>
              </ion-button>
            </ion-buttons>
            <ion-title align="center" *ngIf="quizGameState.currentQuestion < quizGameState.roundHashes.length - 1">
              {{ i + 1 }}/{{ puzzleConfig.questions.length }}
            </ion-title>
            <ion-buttons slot="end">
              <ion-button (click)="fastForward()"
                          [disabled]="!quizGameState.userInput[i]"
                          *ngIf="quizGameState.currentQuestion >= quizGameState.roundHashes.length - 1">
                {{ "QUIZ.board.finished_button.text"| translate }}
                <ion-icon name="arrow-redo-sharp" slot="end"></ion-icon>
              </ion-button>
              <ion-button (click)="nextQuestion()"
                          [disabled]="!quizGameState.userInput[i]"
                          *ngIf="quizGameState.currentQuestion < quizGameState.roundHashes.length - 1">
                <ion-icon name="arrow-forward-sharp" slot="icon-only"></ion-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
          <ion-content style="--padding-top: 56px;">
            <ion-grid style="display: flex; flex-direction: column; height: 100%;">
              <ion-row class="question">
                <ion-col class="question-inner">
                  <div class="ion-text-center">
                    <h2 class="question-text">{{ question.question }}</h2>
                  </div>
                </ion-col>
              </ion-row>
              <ion-row style="flex-grow: 1;">
                <ion-col style="display: flex; flex-direction: row; flex-wrap: wrap;">
                  <div class="answer" *ngFor="let answer of question.answers; let j = index"
                       style="width: 50%;">
                    <ion-button
                      size="large"
                      (click)="selectAnswer(j)"
                      class="answer-button"
                      [class]="getButtonColor(i, j)"
                    >
                      <!--                                [color]="getButtonColor(i, j)">-->
                      <ion-label>{{ answer }}</ion-label>
                    </ion-button>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-content>
        </ion-card>

        <ion-card class="quiz-card-face quiz-card-back puzzle-elevation-z3">
          <div class="krupion-logo"></div>
        </ion-card>
      </div>
    </div>
  </div>

</div>

<div #questionIndicator *ngIf="quizGameState"
     [style.transform]="'scale(' + scaleFactor + ')'"
     [@slideAnimation]="'fade'" class="question-indicator">
  <div>
    <span *ngFor="let question of puzzleConfig.questions; let i = index"
          [ngClass]="getIndicatorClasses(i)"
          (click)="selectCurrectQuestion(i)"
          class="question-indicator-bullet">
    </span>
  </div>
  <div class="fast-forward-button">
    <ion-button color="primary"
                fill="clear"
                size="small"
                (click)="fastForward()"
                *ngIf="canGoFF()">
      <ion-icon name="play-forward-sharp" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</div>
